import { Switch } from "@cntrl/ui";
import { useCanSwitchFixtureAccounts } from "../../app/hooks/useDevFixtureSwitch.js";
import { useFixtureSwitchVisibility } from "../../app/fixtureSwitchVisibility.js";
import settingsStyles from "../settings/SettingsScreen.module.scss";

/**
 * DEV-ONLY Settings › Account row that shows or hides the top bar's "View as" button, for screenshots. Renders
 * only where the button itself could render, so it never appears in production or for a real account. Shared
 * by the band and org Account tabs: the preference is per device, and an org fixture has no band Settings.
 */
export function FixtureSwitchVisibilityToggle() {
  const canSwitch = useCanSwitchFixtureAccounts();
  const hidden = useFixtureSwitchVisibility((s) => s.hidden);
  const setHidden = useFixtureSwitchVisibility((s) => s.setHidden);

  if (!canSwitch) return null;

  return (
    <div className={settingsStyles.toggleRow}>
      <span className={settingsStyles.toggleText}>
        <span className={settingsStyles.toggleLabel}>"View as" button</span>
        <span className={settingsStyles.toggleDesc}>
          (DEBUG) Show the account switcher in the top bar. Turn off for screenshots.
        </span>
      </span>
      <Switch checked={!hidden} onChange={(show) => setHidden(!show)} label={'"View as" button'} />
    </div>
  );
}
